import React, { useEffect, useState } from 'react';
import axios from '../../config/axiosInterceptor';
import { toast } from 'react-toastify';
import axiosInstance from '../../config/axiosInterceptor';

const ManageCompanyInfo = () => {
  const [formData, setFormData] = useState({
    gstNumber: '', address: '', companyEmail: '', mobileNumber: '',
    CIN: '', description: '', HSNCode: ''
  });
  const [logo, setLogo] = useState(null);
  const [signatureImage, setSignatureImage] = useState(null);
  const [stamp, setStamp] = useState(null);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_BASEURL5}/admin/company-info`).then(res => {
      if (res.data.success && res.data.data) {
        const info = res.data.data;
        setFormData({
          gstNumber: info.gstNumber,
          companyName: info.companyName,
          address: info.address,
          companyEmail: info.companyEmail,
          mobileNumber: info.mobileNumber,
          CIN: info.CIN,
          description: info.description,
          HSNCode: info.HSNCode,
          invoiceSendEmail: info.invoiceSendEmail,
          invoiceSendPassword: info.invoiceSendPassword,

        });
      }
    });
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let conf = window.confirm("Are you sure you want to update info");
    if(!conf) return;
    const data = new FormData();
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    if (logo) data.append('logo', logo);
    if (signatureImage) data.append('signatureImage', signatureImage);
    if (stamp) data.append('stamp', stamp);

    try {
      const res = await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/company-info`, data);
      if (res.data.success) toast.success(res.data.message);
      else toast.error(res.data.message);
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="container">
      <h2>Manage Company Info</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="companyName" placeholder="Company Name" value={formData.companyName} onChange={handleChange} className="form-control mb-2" />
        <input type="text" name="gstNumber" placeholder="GST Number" value={formData.gstNumber} onChange={handleChange} className="form-control mb-2" />
        <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} className="form-control mb-2" />
        <input type="email" name="companyEmail" placeholder="Company Email" value={formData.companyEmail} onChange={handleChange} className="form-control mb-2" />
        <input type="text" name="mobileNumber" placeholder="Mobile Number" value={formData.mobileNumber} onChange={handleChange} className="form-control mb-2" />
        <input type="text" name="CIN" placeholder="CIN" value={formData.CIN} onChange={handleChange} className="form-control mb-2" />
        <textarea name="description" placeholder="Description" value={formData.description} onChange={handleChange} className="form-control mb-2" />
        <input type="text" name="HSNCode" placeholder="HSN Code" value={formData.HSNCode} onChange={handleChange} className="form-control mb-2" />
        <input type="email" name="invoiceSendEmail" placeholder="Invoice Send Email" value={formData.invoiceSendEmail} onChange={handleChange} className="form-control mb-2" />
        <input type="password" name="invoiceSendPassword" placeholder="Invoice Send Password" value={formData.invoiceSendPassword} onChange={handleChange} className="form-control mb-2" />
        
        <div className="form-group">
          <label>Logo</label>
          <input type="file" onChange={e => setLogo(e.target.files[0])} className="form-control mb-2" />
        </div>
        <div className="form-group">
          <label>Signature Image</label>
          <input type="file" onChange={e => setSignatureImage(e.target.files[0])} className="form-control mb-2" />
        </div>
        <div className="form-group">
          <label>Stamp</label>
          <input type="file" onChange={e => setStamp(e.target.files[0])} className="form-control mb-2" />
        </div>

        <button type="submit" className="btn btn-success">Save</button>
      </form>
    </div>
  );
};

export default ManageCompanyInfo;
